import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import { Stack, Typography } from '@mui/material';
import { BLUE, INTER, NAVY } from '../../studentStyles';

// Teacher-authored text on a card: the legacy prompt (instructions or teaching
// material) and authored responses. Replaces the chat bubbles of the old player.
export default function TeacherNote({ text, tone = 'info', compact = false }: { text: string; tone?: 'info' | 'success' | 'warning'; compact?: boolean }) {
    const background = tone === 'success' ? 'rgba(47, 143, 104, 0.10)' : tone === 'warning' ? 'rgba(244, 201, 93, 0.22)' : `${BLUE}0F`;
    return (
        <Stack direction="row" spacing={1} alignItems="flex-start" sx={{ p: compact ? 1.25 : 1.5, borderRadius: '14px', backgroundColor: background }}>
            <SchoolRoundedIcon aria-hidden="true" sx={{ color: BLUE, fontSize: 18, mt: '1px', flexShrink: 0 }} />
            <Typography sx={{ fontFamily: INTER, fontSize: 13, color: NAVY, lineHeight: 1.5 }}>{text}</Typography>
        </Stack>
    );
}
